export default __webpack_public_path__ + "static/media/ev_noti.7aa7486d.png";